import { useContext } from 'react'

import { UserDataContext } from '../context'

/**
 * The {@link useUserData} hook return logged user data
 *
 * @return {*}
 */
export function useUserData() {
  return useContext(UserDataContext)
}
